<div class="bg-blue-main">
  <div class="card">
    <div class="card-header flex-between">
      <h5>{{ pageHeading }}</h5>
      <div class="flex-start">
        <ng-container *ngIf="jobDetails">
          <span class="border-right">
            <div class="text-bold">Resource Group</div>
            <div>{{ resourceGroup || "-" }}</div>
          </span>
          <span class="border-right">
            <div class="text-bold">Scanned on</div>
            <div>{{ jobDetails["scanned_date_time_label"] || "-" }}</div>
          </span>
          <span>
            <div class="text-bold">Status</div>
            <div>{{ jobDetails["status"] || "-" }}</div>
          </span>
        </ng-container>
        <button class="btn btn-light" (click)="refresh(true)">Refresh</button>
        <button class="btn btn-primary-soft" (click)="createScan(true)">Scan</button>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="card">
      <div class="card-body table-acm-container">
        <nav class="tabs-container">
          <div class="nav nav-tabs" role="tablist">
            <a
              class="nav-link"
              [ngClass]="{ active: currentPage == 'utilization', show: currentPage == 'utilization' }"
              (click)="setCurrentPage('utilization')"
              role="tab"
            >
              Utilization
            </a>
            <a
              class="nav-link"
              [ngClass]="{ active: currentPage == 'processor', show: currentPage == 'processor' }"
              (click)="setCurrentPage('processor')"
              role="tab"
            >
              Processor
            </a>
            <a
              class="nav-link"
              [ngClass]="{ active: currentPage == 'os', show: currentPage == 'os' }"
              (click)="setCurrentPage('os')"
              role="tab"
            >
              OS
            </a>
          </div>
        </nav>

        <div class="pink_margin">
          {{ recommendationSummary }}
        </div>

        <div class="flex_gap10">
          <div>Potential Saving:</div>
          <div>
            <span class="green_text fontsize_em">{{ getTotalSavings() }} USD</span>
          </div>
          <div *ngIf="loading">
            <img src="../assets/img/loading_2.svg" alt="loading scans" class="width15_margin10" />
          </div>
        </div>

        <div class="overflow_auto2">
          <table class="table table-docs table-hover cost-table">
            <thead>
              <tr>
                <th>S.N.</th>
                <th *ngFor="let h of getCurrentHeaders()">
                  {{ h.name }}
                  <span *ngIf="h.filter" class="inputseach">
                    <input autocomplete="off" type="text" [(ngModel)]="h.filterText" />
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                </th>
              </tr>
            </thead>

            <tbody
              [ngStyle]="{ display: getCurrentRows().length > 0 ? 'table-row-group' : 'none' }"
              *ngFor="
                let row of getCurrentRows()
                  | paginate
                    : {
                        itemsPerPage: currentPagination['perPage'],
                        currentPage: currentPagination['page'],
                        totalItems: getCurrentRows().length
                      };
                let i = index
              "
            >
              <tr *ngIf="notifier.filterTableColums(getCurrentHeaders(), row)">
                <td>{{ currentPagination["perPage"] * (currentPagination["page"] - 1) + i + 1 }}</td>
                <td *ngFor="let h of getCurrentHeaders()">{{ getCellValue(row, h.id) }}</td>
              </tr>
            </tbody>

            <tbody
              *ngIf="getCurrentRows().length == 0 && jobDetails && (jobDetails['status'] || '').toLowerCase() == 'completed'"
            >
              <tr>
                <td [attr.colspan]="getCurrentHeaders().length + 1" class="center">
                  No {{ getCurrentTabLabel() }} recommendations found.
                  Click <span class="nav-link" (click)="createScan(true)">here</span> to scan
                </td>
              </tr>
            </tbody>

            <tbody *ngIf="!jobDetails && !fetching">
              <tr>
                <td [attr.colspan]="getCurrentHeaders().length + 1" class="center">
                  No Scans Found. Click <span class="nav-link" (click)="createScan(true)">here</span> to scan
                </td>
              </tr>
            </tbody>

            <tbody *ngIf="fetching">
              <tr>
                <td [attr.colspan]="getCurrentHeaders().length + 1" class="center">
                  <div class="flex-center">
                    <img src="../assets/img/loading_2.svg" alt="loading scans" class="width-18" />
                    <span *ngIf="jobDetails">{{ jobDetails["status"] }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator">
          <div class="flex-start">
            <span class="no-wrap">Per Page</span>
            <select class="form-select" [(ngModel)]="currentPagination['perPage']" (change)="currentPagination['page'] = 1">
              <option value="{{ page }}" *ngFor="let page of pages">{{ page }}</option>
            </select>
          </div>
          <pagination-controls
            class="pagination"
            previousLabel="Prev"
            nextLabel="Next"
            (pageChange)="currentPagination['page'] = $event"
          >
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
